export default "https://cdn-static.gokick.com/assets/a6d011c942efc1c6cd2854aca00adc3db9e08265/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";